declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    confetti: any;
  }
}

function randomInRange(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export const confetti = (palette: Array<number>) => {
  window.confetti({
    ticks: 300,
    particleCount: 500,
    scalar: 3,
    shapes: ["square"],
    colors: palette.map((n) => `#${n.toString(16).padStart(6, "0")}`),
    // randomise a direction
    angle: randomInRange(55, 125),
    spread: randomInRange(50, 70),
    origin: {
      x: randomInRange(0.3, 0.7),
      y: randomInRange(0.3, 0.7),
    },
  });
};
